export default __webpack_public_path__ + "static/media/caret-down.6a9f66c1.svg";